export default () => ({
  tokenWithoutBearer: null,
  user: {},
  topInsurance: false,
  directInsurance: false,
  path: null,
  sanierungsStatus: null,
  // Dokumenten-Flags aus /customer/status/documents. null = noch nicht geprueft.
  documentStatus: {
    resolved: false,
    sigma: {
      has_signed_contract: null,
      has_existenzschutz: null
    },
    starpool_signed: null,
    starpool_wuerzburger_signed: null,
    gbv: {
      has_signature: null
    }
  },
  krankenkasse: {
    resolved: false,
    show: false,
    subscribed: false
  }
})
